import './table.css';

function Table({
    columns,
    data,
    pageTotal,
    onChangePage = () => {},
    maxHeight = '500px',
    maxWidth = '700px',
    minWidth = '200px',
    margin = '0 15px',
    usePagination = true,
    getRowProps = () => ({}),
    rowKey = 'id'
}) {
    function hasMore() {
        return data.length < pageTotal;
    }

    function resolveRowKey(row, rowIndex) {
        if (typeof rowKey === 'function')
            return rowKey(row, rowIndex);

        return row?.[rowKey] ?? rowIndex;
    }

    return (
        <>
            <div className='table-scroll'>
                <div className='table-scroll-inner'>
                    <table className='table-glass' style={{ maxWidth, minWidth, margin }}>
                        <thead>
                            <tr>
                                {columns.map((col, index) => (
                                    <th key={index} style={{ width: col.width ?? 'auto' }}>{col.title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody style={{ maxHeight }}>
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                                        Sem registros
                                    </td>
                                </tr>
                            ) : (
                                data.map((row, rowIndex) => (
                                    <tr key={resolveRowKey(row, rowIndex)} {...getRowProps(row, rowIndex)}>
                                        {columns.map((col, colIndex) => (
                                            <td key={colIndex} style={{ width: col.width ?? 'auto' }}>
                                                {col.render
                                                    ? col.render(row[col.dataIndex], row)
                                                    : row[col.dataIndex]
                                                }
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {usePagination && (
                        <div className='table-pagination'>
                            <span className='table-pagination-total'>Quantidade: {data.length} de {pageTotal}</span>

                            <button
                                className='border-button glass-button-effect-15'
                                disabled={!hasMore()}
                                onClick={onChangePage}>
                                Carregar mais
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default Table;